export default __webpack_public_path__ + "static/media/web.22f69d11.config";